import React from 'react'
import classNames from 'classnames'
import styles from './styles.module.scss'

export interface IProps {
  icon: string
  color?: string
  pointer?: boolean
  disabled?: boolean
  style?: React.CSSProperties
  size?: string
  className?: string
  onClick?: (e?: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void
}

const Icon: React.FC<IProps> = ({ className, icon, color, pointer, disabled = false, style, size, onClick }) => {
  const chooseTypeCursor = () => {
    if (disabled) {
      return 'not-allowed'
    } else {
      return pointer ? 'pointer' : 'unset'
    }
  }

  return (
    <span
      style={{ ...style, cursor: chooseTypeCursor() }}
      onClick={onClick}
      className={classNames([styles['icomoon']], {
        [`${className}`]: className,
        [`icon-${icon}`]: icon,
        [styles[`color-${color}`]]: color,
        [styles[`size-${size}`]]: size
      })}
    />
  )
}

export default Icon
